'use client';

import { useVariantQuantity } from '../contexts/variant-quantity/context';
import { QuantitySelector } from './QuantitySelector';

/**
 * Quantity stepper wired to the PDP context. Renders nothing outside the
 * provider or for fixed-quantity listings (digital, meeting, etc., where
 * `isFixedToOne` is true). Mirrors RN's `secondaryActions` quantity slot.
 */
export function QuantityRow() {
  const ctx = useVariantQuantity();
  if (!ctx) return null;

  return (
    <QuantitySelector
      quantity={ctx.quantity}
      maxQuantity={ctx.maxQuantity}
      isFixedToOne={ctx.isFixedToOne}
      isSoldOut={ctx.isSoldOut}
      onChange={ctx.setQuantity}
    />
  );
}
